import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { IDropDown } from 'bi-interfaces/lib/interfaces/IDropDownList';

@Component({
  selector: 'bi-dropDown',
  templateUrl: './bi-drop-down.component.html',
  styleUrls: ['./bi-drop-down.component.scss']
})
export class BiDropDownComponent implements IDropDown {
  @ViewChild("bindingDrop") public bindingDrop!: any;
  @Input() IsDisabled: boolean = false;
  @Output() OnValueChange = new EventEmitter<any>();
  @Output() OnselectionChange = new EventEmitter<any>();
  @Output() OnFocus = new EventEmitter<any>();
  @Output() OnOpen = new EventEmitter<any>();
  FilterData: any[] | undefined=[];
  orig: any[] =[]

  
  @Input() SelectedRow: any;
  @Input() DropDownList!: any[]|undefined
  @Input() TextField: any
  @Input() ValueField: any
  @Input() BindingProperty!: FormControl;
  @Input() DefaultItem: any;
  @Input() Name: any;
  @Input() HasStatuesIcon: boolean = false;
  @Input() IsFilterable: boolean = false;
  @Input() style?: string;
  @Input() DomId?: string;
  @Input() title!: string;
  @Input() styleType: 'small' | 'medium' | 'large' | 'none' = 'medium';

  valueChange(event: any) {
    this.OnValueChange.emit(event);
    if (this.BindingProperty) {
      this.BindingProperty.patchValue(event);

    }
  }
  selectionChange(event: any) {
    this.OnselectionChange.emit(event);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.DropDownList && changes['DropDownList']?.currentValue) {

      this.FilterData=this.DropDownList.slice();
    }
  }

  public focus(): void {
    this.OnFocus.emit(null);
  }
  public open(): void {
   
    if(this.DropDownList && (!this.FilterData||this.FilterData?.length==0))
      this.FilterData=this.DropDownList.slice();
    this.OnOpen.emit(null);
  }
  

  handleFilter(value:any) {
   if(!value)
    {
    
      if(this.DropDownList)
        this.FilterData=this.DropDownList.slice();
    }
    else
    {
      this.FilterData = this.DropDownList?.filter(
        (s) => s[this.TextField]?.toLowerCase().indexOf(value?.toLowerCase()) !== -1
      );
    }
  }

}
